import React from "react";
import Select from "react-select";

interface DistrictJCandCOMProps {
  apmcName: string;
  districtName: string;
  agreeTerms: boolean;
  setAgreeTerms: (value: boolean) => void;
  issued?: boolean;
  agreeError: boolean;
  setAgreeError: (value: boolean) => void;
  certificateData: any;
  setCertificateData: any;
}

export const DistrictJCandCOM: React.FC<DistrictJCandCOMProps> = ({
  certificateData,
  setCertificateData,
  issued,
  apmcName,
  districtName,
  agreeTerms,
  setAgreeTerms,
  agreeError,
  setAgreeError,
}) => {
  // options: same `value` for sync, different labels for GU/EN
  const gujaratiOptions = [
    { value: "capable", label: "સક્ષમ" },
    { value: "not_capable", label: "અસક્ષમ" },
  ];

  const englishOptions = [
    { value: "capable", label: "capable" },
    { value: "not_capable", label: "not capable" },
  ];

  // inline small select styles for react-select
  const inlineSelectStyles = {
    container: (base: any) => ({
      ...base,
      width: "120px",
      display: "inline-block",
      verticalAlign: "middle",
      marginLeft: 6,
      marginRight: 6,
    }),
    control: (base: any) => ({
      ...base,
      minHeight: "22px",
      height: "28px",
      fontSize: "14px",
      borderRadius: 4,
      boxShadow: "none",
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "0 6px",
      height: "28px",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: "28px",
    }),
    singleValue: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      padding: "0 6px",
    }),
    input: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  return (
    <div
      className={`d-flex gap-3 border p-3 rounded-2 mb-2 
        ${agreeError ? "bg-danger-subtle border-danger" : "bg-white border-secondary"}`}
    >
      {/* Checkbox */}
      <div className="pt-2">
        {!issued && (
          <input
            className="form-check-input"
            type="checkbox"
            name="agreeTerms"
            id="agreeTerms_COM"
            checked={agreeTerms}
            onChange={(e) => {
              setAgreeTerms(e.target.checked);
              setAgreeError(false); // clear error on check
            }}
            style={{ transform: "scale(1.5)" }}
          />
        )}
        {issued && <span className="text-success fw-bold">✅ </span>}
      </div>

      <div>
        <p>
          ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
          <input
            type="text"
            value={apmcName}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`,
              minWidth: "40px",
              maxWidth: "100%",
            }}
            readOnly
          />
          એ કરેલ અરજીના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર
          સમિતિની दरખાસ્ત નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર
          <input
            type="text"
            value={"Gujarat"}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`,
              minWidth: "50px",
              maxWidth: "100%",
            }}
            readOnly
          />
          ,અને જિલ્લા રજિસ્ટ્રાર, સ.મં.
          <input
            type="text"
            value={districtName}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${districtName?.length > 0 ? districtName.length : 1}ch`,
              minWidth: "40px",
              maxWidth: "100%",
            }}
            readOnly
          />
          / નિયુક્ત પ્રતિનિધિ શ્રી
          <input
            type="text"
            value={certificateData.FilledFormName}
            onChange={(e) => setCertificateData({ ...certificateData, FilledFormName: e.target.value })}
            className="mx-1 border-0 border-bottom border-secondary mb-3"
            readOnly={issued ? true : false}
          />
          હોદ્દો
          <input
            type="text"
            value={certificateData.positionName}
            onChange={(e) => setCertificateData({ ...certificateData, positionName: e.target.value })}
            className="mx-1 border-0 border-bottom border-secondary mb-3"
            readOnly={issued ? true : false}
          />
          એ સ્થળ તપાસ કરેલ છે. આ વિગતોના આધારે મારો સ્પષ્ટઅભિપ્રાય છે કે બજાર સમિતિએ સહાય મેળવવા માંગણી
          કરેલ પ્રોજેકટ પૂર્ણ કરવા
          <span>
            <Select
              styles={inlineSelectStyles}
              options={gujaratiOptions}
              value={gujaratiOptions.find((o) => o.value === certificateData.projectCapability)}
              onChange={(selected: any) =>
                setCertificateData({
                  ...certificateData,
                  projectCapability: selected?.value,
                })
              }
              isDisabled={issued}
            />
          </span>
          છે.
        </p>

        <p>
          (The Agricultural Produce Market Committee,
          <input
            type="text"
            value={apmcName}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`,
              minWidth: "40px",
              maxWidth: "100%",
            }}
            readOnly
          /> has filled in all the details in the application form, which have been verified and found to
          be correct. The said proposal of the Market Committee has been inspected on-site by the Deputy
          Director of Agricultural Market and Rural Economy,
          <input
            type="text"
            value={"Gujarat"}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`,
              minWidth: "50px",
              maxWidth: "100%",
            }}
            readOnly
          />{" "}
          and the District Registrar, Co-operative Societies,
          <input
            type="text"
            value={districtName}
            className="border-0 border-bottom border-secondary mb-3"
            style={{
              width: `${districtName?.length > 0 ? districtName.length : 1}ch`,
              minWidth: "40px",
              maxWidth: "100%",
            }}
            readOnly
          />{" "}
          / appointed representative Shri
          <input
            type="text"
            value={certificateData.FilledFormName}
            onChange={(e) => setCertificateData({ ...certificateData, FilledFormName: e.target.value })}
            className="mx-1 border-0 border-bottom border-secondary mb-3"
            readOnly={issued ? true : false}
          />
          Designation
          <input
            type="text"
            value={certificateData.positionName}
            onChange={(e) => setCertificateData({ ...certificateData, positionName: e.target.value })}
            className="mx-1 border-0 border-bottom border-secondary mb-3"
            readOnly={issued ? true : false}
          />{" "}
          Based on these details, my clear opinion is that the Market Committee is
          <span>
            <Select
              styles={inlineSelectStyles}
              options={englishOptions}
              value={englishOptions.find((o) => o.value === certificateData.projectCapability)}
              onChange={(selected: any) =>
                setCertificateData({
                  ...certificateData,
                  projectCapability: selected?.value,
                })
              }
              isDisabled={issued}
            />
          </span>{" "}
          of completing the project for which assistance has been requested)
        </p>
      </div>
    </div>
  );
};

export default DistrictJCandCOM;
